import { RadioButton } from "@progress/kendo-react-inputs";
import { ErrorMessage, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { SetMaskOnOff } from "src/Basic/SDOExtension";
import TextInput from "src/Components/Input/TextInput";
import { dsicValidateField, olapValidateField, niaValidateField, StyledSearchTable } from "./CaseProgress.service";
import { Error } from "@progress/kendo-react-labels";
import { Captcha } from "src/Components/Captcha/Captcha";
import { getCaptchaService } from "src/HomePage/CaptCha.service";

/**
 * 案件進度查詢表單
 * @param {*} props 
 * @param {*} onSubmit 處理表單資料
 * @returns 
 */
const CaseProgressSearch = (props) => {

    //首次載入
    const [firstLoad, setFirstLoad] = useState(true);
    //搜尋種類
    const [OrgSys, setType] = useState('DSIC');
    //表單ref
    const formRef = useRef();
    const initCaptchaEncode = { CaptchaEncode: "" };
    const [captchaTxt, setCaptcha] = useState(initCaptchaEncode);

    useEffect(() => {
        if (firstLoad) {
            setFirstLoad(false);
            getCaptcha();
        }
    }, [])

    /**
     * 切換搜尋種類，清空表單
     */
    const formSwitsh = React.useCallback(e => {
        setType(e.value);
        formRef.current.resetForm();
        formRef.current.setValues({
            OrgSys: e.value,
            DocNo: '',
            postOfficeBarcode: '',
            diliverBarcode: '',
            OrgNam: '',
            IcNo: '',
            SendNo: '',
            captcha: ''
        })
    }, [setType]);

    //取得驗證碼
    const getCaptcha = async (e) => {
        if (e) e.preventDefault();
        const captchaData = await getCaptchaService();
        if (captchaData) {
            setCaptcha(captchaData);
        }
    };

    /**
     * Formik 表單 submit
     * @param {*} data 
     */
    const submit = async (data) => {
        SetMaskOnOff(true);
        var formData = {
            ...data,
            Captcha: data.captcha,
            CaptchaEncoded: captchaTxt.CaptchaEncode
        }
        await props.onSubmit(formData)
        SetMaskOnOff(false);
    }
    /**
     * 驗證
     * @param {*} OrgSys 
     * @returns 
     */
    const validationSchema = (OrgSys) => {
        switch (OrgSys) {
            case 'DSIC':
                return dsicValidateField;
            case 'OLAP':
                return olapValidateField;
            case 'NIA':
                return niaValidateField;
        }
    }

    return (
        <>

            <div className="form_white_box">
                <div className="border_bottom font_18_700" style={{ marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>案件類型</span>
                    <a
                        href="https://olap.moeaic.gov.tw/user/PGRS_Index.aspx"
                        target="_blank"
                        rel="noreferrer"
                        style={{ fontSize: '15px', fontWeight: '400' }}
                    >
                        舊版線上申辦進度查詢
                    </a>
                </div>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        OrgSys: OrgSys,
                        PostNo: '',
                        DocNo: '', //收文文號
                        postOfficeBarcode: '', //郵局條碼編號
                        diliverBarcode: '', // 快遞條碼編號
                        OrgNam: '', //邀請單位
                        IcNo: '', //團號
                        SendNo: '',
                        captcha: '',
                        CaptchaEncoded: "",

                    }}
                    validationSchema={validationSchema(OrgSys)}
                    onSubmit={(data) => submit(data)}
                >
                    {prop => {
                        const {
                            values,
                            errors,
                            handleSubmit,
                            handleChange,
                            setFieldValue
                        } = prop;
                        return (
                            <form>
                                <div className="Report-table">
                                    <StyledSearchTable>
                                        <tbody>
                                            <tr>
                                                <ul className="checkboxList" style={{ 'display': 'flex', 'justifyContent': 'center' }}>
                                                    <li style={{ 'whiteSpace': 'nowrap' }}>
                                                        <span style={{ 'whiteSpace': 'nowrap', 'display': 'flex', 'alignItems': 'center' }}>
                                                            <RadioButton name={'OrgSys'} value={'DSIC'} checked={OrgSys === 'DSIC'}
                                                                onChange={(e) => {
                                                                    setFieldValue('OrgSys', 'DSIC');
                                                                    formSwitsh(e);
                                                                }}>
                                                                一般申請案件
                                                            </RadioButton>
                                                        </span>
                                                    </li>
                                                    <li style={{ 'whiteSpace': 'nowrap' }}>
                                                        <span style={{ 'whiteSpace': 'nowrap', 'display': 'flex', 'alignItems': 'center' }}>
                                                            <RadioButton name={'OrgSys'} value={'NIA'} checked={OrgSys === 'NIA'}
                                                                onChange={(e) => {
                                                                    setFieldValue('OrgSys', 'NIA');
                                                                    formSwitsh(e);
                                                                }} >
                                                                大陸人士查詢
                                                            </RadioButton>
                                                        </span>
                                                    </li>
                                                    <li style={{ 'whiteSpace': 'nowrap' }}>
                                                        <span style={{ 'whiteSpace': 'nowrap', 'display': 'flex', 'alignItems': 'center' }}>
                                                            <RadioButton name={'OrgSys'} value={'OLAP'} checked={OrgSys === 'OLAP'}
                                                                onChange={(e) => {
                                                                    setFieldValue('OrgSys', 'OLAP');
                                                                    formSwitsh(e);
                                                                }} >
                                                                線上申辦查詢
                                                            </RadioButton>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </tr>
                                            {OrgSys == 'DSIC' &&
                                                <>

                                                    <tr>
                                                        <td>
                                                            <TextInput
                                                                className="form-control margin_t10 k-input k-input-md k-rounded-md k-input-solid"
                                                                id="DocNo"
                                                                name="DocNo"
                                                                placeholder="請輸入10碼收文文號"
                                                                errors={errors.DocNo}
                                                                value={values.DocNo}
                                                                onChange={handleChange}
                                                                maxLength={10}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <TextInput
                                                                className="form-control margin_t10 k-input k-input-md k-rounded-md k-input-solid"
                                                                id="postOfficeBarcode"
                                                                name="postOfficeBarcode"
                                                                placeholder="請輸入郵局條碼編號"
                                                                errors={errors.postOfficeBarcode}
                                                                value={values.postOfficeBarcode}
                                                                onChange={handleChange}
                                                                maxLength={20}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <TextInput
                                                                className="form-control margin_t10 k-input k-input-md k-rounded-md k-input-solid"
                                                                id="diliverBarcode"
                                                                name="diliverBarcode"
                                                                placeholder="請輸入快遞條碼編號"
                                                                errors={errors.diliverBarcode}
                                                                value={values.diliverBarcode}
                                                                onChange={handleChange}
                                                                maxLength={20}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <Error>{errors?.onlyone}</Error>
                                                </>
                                            }
                                            {OrgSys == 'NIA' &&
                                                <>
                                                    <tr>
                                                        <td>
                                                            <TextInput
                                                                className="form-control margin_t10 k-input k-input-md k-rounded-md k-input-solid"
                                                                id="OrgNam"
                                                                name="OrgNam"
                                                                placeholder="請輸入邀請單位"
                                                                errors={errors.OrgNam}
                                                                value={values.OrgNam}
                                                                onChange={handleChange}
                                                                maxLength={40}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <TextInput
                                                                className="form-control margin_t10 k-input k-input-md k-rounded-md k-input-solid"
                                                                id="IcNo"
                                                                name="IcNo"
                                                                placeholder="請輸入團號"
                                                                errors={errors.IcNo}
                                                                value={values.IcNo}
                                                                onChange={handleChange}
                                                                maxLength={20}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <Error>{errors?.OrgNam}</Error>
                                                </>
                                            }
                                            {OrgSys == 'OLAP' &&
                                                <>
                                                    <tr>
                                                        <td>
                                                            <TextInput
                                                                className="form-control margin_t10 k-input k-input-md k-rounded-md k-input-solid"
                                                                id="SendNo"
                                                                name="SendNo"
                                                                placeholder="請輸入線上申辦送件編號"
                                                                errors={errors.SendNo}
                                                                value={values.SendNo}
                                                                onChange={handleChange}
                                                                maxLength={20}
                                                            />
                                                            <Error>{errors?.SendNo}</Error>
                                                        </td>
                                                    </tr>
                                                </>
                                            }
                                            <tr>
                                                <td>
                                                    <div className="flex">
                                                        <div className="me-lg-auto-width">
                                                            <TextInput
                                                                className="form-control margin_t10 k-input k-input-md k-rounded-md k-input-solid"
                                                                id="captcha"
                                                                name="captcha"
                                                                placeholder="請輸入驗證碼"
                                                                errors={errors.captcha}
                                                                value={values.captcha}
                                                                onChange={handleChange}
                                                            />
                                                            <Error>{errors?.captcha}</Error>
                                                        </div>
                                                        <div className="flex_center">
                                                            <div className="margin_xl10">
                                                                {captchaTxt.Img && (
                                                                    <Captcha
                                                                        Img={captchaTxt.Img}
                                                                        GetCaptcha={getCaptcha}
                                                                    />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </StyledSearchTable>
                                </div>
                                <div className="items_folder_btn_box text-center">
                                    <button
                                        type="button"
                                        onClick={handleSubmit}
                                        className="k-button k-button-md k-button-solid k-button-solid-base k-rounded-md personal_Information_item"
                                        style={{
                                            'padding': '16px 36px',
                                            'gap': '10px',
                                            'background': 'rgb(0, 166, 152)',
                                            'fontSize': '18px',
                                            'fontWeight': '500',
                                            'lineHeight': '26px',
                                            'textAlign': 'center',
                                            'color': 'rgb(255, 255, 255)',
                                            margin: "30px 0 0 0"
                                        }}
                                    >

                                        開始查詢
                                    </button>
                                </div>
                            </form>
                        )
                    }}
                </Formik>
                <div className="form_blue_box font_15_400" style={{ 'height': 'auto' }}>
                    <ul>
                        <li>
                            ＊ 若為補件資料，查詢案件進度仍請以原申請案件之收文號（如投增資、轉受讓、投增資備查等）查詢，若仍有疑問，請電洽本司，電話 (02)3343-5700。
                        </li>
                        <li>
                            ＊ 您所查詢的案件若已結案超過三個月，本系統將無法提供資料。
                        </li>
                        <li>
                            ＊ 請輸入
                            <span className="Utils_red__rgXaR">
                                [收文文號]。
                            </span>
                            <span style={{ color: '#e75731' }}>
                                限定為10碼，若您的號碼為11碼，請將最後一碼去除。
                            </span>
                        </li>
                        <li>
                            ＊ 郵寄者請輸入
                            <span className="Utils_red__rgXaR">
                                [郵局條碼編號]。
                            </span>
                        </li>
                        <li>
                            ＊ 快遞者請輸入完整
                            <span className="Utils_red__rgXaR">
                                [快遞條碼編號]。
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default CaseProgressSearch;